<template>
    <client-page class="wrap--join">
		<!-- 메인 -->
		<main class="main" role="main">
			<div class="inner">
                <h2 class="join-title">회원가입</h2>

				<div class="join-container">
					<!-- 가입 단계 표시 -->
					<nav class="join-step">
						<ul class="join-step-lists">
							<li class="list list--on">
								<span class="badge">1</span>
								<span class="text">약관동의</span>
							</li>
							<li class="list">
								<span class="badge">2</span>
								<span class="text">정보입력</span>
							</li>
							<li class="list">
								<span class="badge">3</span>
								<span class="text">가입완료</span>
							</li>
						</ul>
					</nav>

					<!-- 약관동의 -->
					<terms-of-agreements ref="terms"></terms-of-agreements>

					<!-- 하단버튼 -->
					<div class="button-group">
                	    <v-btn href="" onclick="return false;" @click="$router.go(-1)" large outlined rounded color="grey" elevation="0" class="min-w-120px min-w-lg-200px"><span class="color-grey">취소하기</span></v-btn>
                	    <v-btn @click="submit" large rounded color="primary" elevation="0" class="min-w-120px min-w-lg-200px"><span>계속 진행</span></v-btn>
                	</div>
					<!-- <div class="bottom-button">
						<a class="button button--border-primary" href="" onclick="return false;" @click="$router.go(-1)"><span>취소하기</span></a>
						<a class="button button--primary" @click="submit"><span>계속 진행</span></a>
					</div> -->
				</div>
			</div>
		</main>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import TermsOfAgreements from "@/components/client/join/terms-of-agreements.vue";

export default {
	components: {
		ClientPage,
		TermsOfAgreements
	},
	methods : {
		submit(){
			try{
				if(this.$refs.terms.check()){
					this.$store.dispatch('agreements', this.$refs.terms.selected)

					this.$router.push({
						path: "/join/form",
						query: this.$route.query
					});
				}
			}
			catch(error){
				alert(error.message.toString());
			}
		}
	},
}
</script>
